import { Navigate } from 'react-router-dom';
import { Route } from '../types/use-routes.interface';
import { makeCommonScreen } from '../factory/others';

export const othersRoutes: Route[] = [makeCommonScreen()];
